<template>
  <Transition
    enter-active-class="transition-opacity duration-200"
    leave-active-class="transition-opacity duration-200"
    enter-class="opacity-0"
    leave-to-class="opacity-0"
  >
    <div
      v-if="hasError"
      role="alert"
      class="flex items-center bg-warning2 text-whiteOverride px-twenty py-base !mb-sm rounded-lg"
      :class="{ '!items-start': errorAdvice || $slots.content }"
    >
      <IconCircular class="border-solid border-2 mr-sm h-twentyFive">
        <ExclamationIcon aria-hidden="true" />
      </IconCircular>

      <div>
        <slot name="content">
          <p
            class="text-14 mb-0"
            :class="{ 'font-bold': errorAdvice }"
          >
            {{ errorMessage }}
          </p>

          <p
            v-if="errorAdvice"
            class="text-14"
          >
            {{ errorAdvice }}
          </p>
        </slot>
      </div>
    </div>
  </Transition>
</template>

<script>
// @ts-check
import { defineComponent } from 'vue';

import { ExclamationIcon, IconCircular } from '@/components/library/icons';

export default defineComponent({
  components: {
    ExclamationIcon,
    IconCircular,
  },
  props: {
    hasError: {
      type: Boolean,
      required: true,
    },
    errorMessage: {
      /** @type {import('vue').PropType<string|null>} */
      type: String,
    },
    errorAdvice: {
      /** @type {import('vue').PropType<string|null>} */
      type: String,
    },
  },
});
</script>
